import Vue from 'vue';
const moment = require('moment')
//require('moment/locale/ar-sa')


//Vue.prototype.$dateFormats = {
//hDDMMYYYY: 'iYYYY/iMM/iDD',
//hFull: 'iYYYY/iMM/iDD hh:mm a'
//}

Vue.use(require('vue-moment'), {
    moment
})
